/* Gregor: carga próxima a pantalla, reproducción silenciosa y pausa fuera de vista. */
(function () {
  'use strict';
  if (window.GregorAutoplay) {
    window.GregorAutoplay.init(document);
    return;
  }
  var videos = new Map();
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var connection = navigator.connection;
  var loadObserver, playObserver;
  function allowed() {
    return !document.hidden && !motion.matches && !(connection && connection.saveData);
  }
  function load(video) {
    if (!video.getAttribute('src') && video.dataset.src) {
      video.src = video.dataset.src;
      video.load();
    }
  }
  function update(video, state) {
    if (!allowed() || !video.isConnected) {
      video.pause();
      return;
    }
    if (state.near || state.visible) load(video);
    if (!state.visible) {
      video.pause();
      return;
    }
    if (video.paused && video.getAttribute('src')) {
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () { /* Respeta la política del navegador. */ });
    }
  }
  function refresh() {
    videos.forEach(function (state, video) { update(video, state); });
  }
  if ('IntersectionObserver' in window) {
    loadObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = videos.get(entry.target);
        if (!state) return;
        state.near = entry.isIntersecting;
        update(entry.target, state);
      });
    }, { rootMargin: '180px 0px', threshold: 0 });
    playObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = videos.get(entry.target);
        if (!state) return;
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
        update(entry.target, state);
      });
    }, { threshold: [0, 0.1] });
  }
  // Compatibilidad sin observers: una comprobación por frame y sólo al desplazarse.
  var scheduled = false;
  function checkPosition() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      videos.forEach(function (state, video) {
        var box = video.getBoundingClientRect();
        var height = window.innerHeight;
        state.near = box.bottom > -180 && box.top < height + 180;
        state.visible = box.height > 0 && box.bottom > box.height * 0.1 && box.top < height - box.height * 0.1;
        update(video, state);
      });
    });
  }
  function init(scope) {
    scope.querySelectorAll('video[data-gregor-autoplay]').forEach(function (video) {
      if (videos.has(video)) return;
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      video.loop = true;
      video.playsInline = true;
      video.removeAttribute('controls');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('disableremoteplayback', '');
      video.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
      // Controla el arranque aquí para evitar autoplay nativo fuera de pantalla.
      video.autoplay = false;
      videos.set(video, { near: false, visible: false });
      if (loadObserver) {
        loadObserver.observe(video);
        playObserver.observe(video);
      }
    });
    if (!loadObserver) checkPosition();
  }
  function unload(event) {
    videos.forEach(function (state, video) {
      if (!video.isConnected || event.target.contains(video)) {
        video.pause();
        if (loadObserver) { loadObserver.unobserve(video); playObserver.unobserve(video); }
        videos.delete(video);
      }
    });
  }
  window.GregorAutoplay = { init: init };
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', unload);
  if (motion.addEventListener) motion.addEventListener('change', refresh);
  else if (motion.addListener) motion.addListener(refresh);
  if (connection && connection.addEventListener) connection.addEventListener('change', refresh);
  if (!loadObserver) {
    window.addEventListener('scroll', checkPosition, { passive: true });
    window.addEventListener('resize', checkPosition, { passive: true });
  }
  init(document);
}());
